import { Upload } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import { useRef } from 'react'
import { upLoadImagePostWeb } from '../../../services/postservice'

const UploadArea = ({
  onFilesSelected,
  onUploadError,
  accept,
  multiple = true,
  maxFiles = 5,
  currentCount = 0,
  fileType = 'file'
}) => {
  const handlingRef = useRef(false)
  const disabled = currentCount >= maxFiles

  const handleFiles = async (fileList) => {
    if (handlingRef.current || disabled) return
    handlingRef.current = true

    const files = fileList.slice(0, maxFiles - currentCount)

    // Phase 1: placeholder
    files.forEach((file, index) => {
      onFilesSelected(null, file, index, true)
    })

    // Phase 2: upload
    for (let index = 0; index < files.length; index++) {
      const file = files[index]
      try {
        const res = await upLoadImagePostWeb([file])
        if (res?.code === 200) {
          onFilesSelected(res.data, file, index, false)
        }
      } catch (err) {
        onUploadError?.(file, err)
      }
    }

    handlingRef.current = false
  }

  return (
    <Upload
      accept={accept}
      multiple={multiple}
      showUploadList={false}
      disabled={disabled}
      beforeUpload={(file, fileList) => {
        handleFiles(fileList)
        return false
      }}
    >
      <div
        style={{
          width: 76,
          height: 76,
          border: '1px dashed #d9d9d9',
          borderRadius: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: disabled ? 'not-allowed' : 'pointer',
          background: disabled ? '#f5f5f5' : '#fafafa',
          color: disabled ? '#bfbfbf' : '#8c8c8c',
          transition: 'all 0.2s ease'
        }}
      >
        <PlusOutlined
          style={{
            fontSize: 16,
            marginBottom: 6,
            color: disabled ? '#bfbfbf' : '#6b3fa0'
          }}
        />
        <div
          style={{
            fontSize: 12,
            fontWeight: 500
          }}
        >
          Thêm {fileType}
        </div>
        <div
          style={{
            fontSize: 12,
            marginTop: 2,
            color: '#bfbfbf'
          }}
        >
          {currentCount}/{maxFiles}
        </div>
      </div>
    </Upload>
  )
}

export default UploadArea
